import React, { useEffect, useState } from "react";
import axios from "axios";
import TopNav from "../../components/navigation/TopNav";
import { useTranslation } from "react-i18next";

import StandardScreen, { ScreenContent } from "../../components/layout/StandardScreen";
import Stack from "../../components/layout/Stack";
import Card from "../../components/ui/Card";
import FormField from "../../components/forms/FormField";
import TextInput from "../../components/forms/TextInput";

import {
  TableShell,
  Table,
  Th,
  Td,
} from "../../components/data/Table";

const narrowShellStyle = {
  width: "100%",
  margin: "0 auto",
};

export default function AdminBusesReport() {
  const { t } = useTranslation();

  const [buses, setBuses] = useState([]);
  const [textFilter, setTextFilter] = useState("");

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;

    axios
      .get(`${process.env.REACT_APP_API_URL}/admin/buses`)
      .then((res) => setBuses(Array.isArray(res.data) ? res.data : []))
      .catch((err) => {
        console.error("❌ Failed to fetch admin buses report", err);
        setBuses([]);
      });
  }, []);

  const formatDateTime = (value) => {
    if (!value) return "-";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";

    return date
      .toLocaleString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(",", "");
  };

  const getText = (value) => (value == null ? "" : String(value).toLowerCase());

  const filteredBuses = buses.filter((bus) => {
    const search = textFilter.toLowerCase().trim();

    return (
      search === "" ||
      getText(bus.bus_id).includes(search) ||
      getText(bus.vendor_id).includes(search) ||
      getText(bus.driver_id).includes(search) ||
      getText(bus.bus_code).includes(search) ||
      getText(bus.plate_number).includes(search) ||
      getText(bus.status).includes(search) ||
      getText(bus.notes).includes(search)
    );
  });

  return (
    <StandardScreen
      topNav={<TopNav title={t("admin_buses_report.title")} mode="main" />}
    >
      <ScreenContent>
        <div style={narrowShellStyle}>
          <Stack gap="4">
            <Card title={t("admin_buses_report.title")}>
              <Stack gap="3">
                <FormField label={t("admin_buses_report.fields.text_filter.label")}>
                  <TextInput
                    value={textFilter}
                    onChange={(e) => setTextFilter(e.target.value)}
                    placeholder={t("admin_buses_report.fields.text_filter.placeholder")}
                  />
                </FormField>
              </Stack>
            </Card>

            <Card>
              <TableShell maxHeight="65vh">
                <Table>
                  <thead>
                    <tr>
                      <Th columnIndex={0} sticky wider>
                        {t("admin_buses_report.table.bus_id")}
                      </Th>

                      <Th columnIndex={1} sticky wider>
                        {t("admin_buses_report.table.bus_code")}
                      </Th>

                      <Th wider>
                        {t("admin_buses_report.table.plate_number")}
                      </Th>

                      <Th wider>
                        {t("admin_buses_report.table.driver_id")}
                      </Th>

                      <Th wider>
                        {t("admin_buses_report.table.vendor_id")}
                      </Th>

                      <Th wider>
                        {t("admin_buses_report.table.status")}
                      </Th>

                      <Th wider>
                        {t("admin_buses_report.table.created_at")}
                      </Th>

                      <Th>
                        {t("admin_buses_report.table.notes")}
                      </Th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredBuses.map((bus) => (
                      <tr key={bus.bus_id}>
                        <Td columnIndex={0} sticky>
                          {bus.bus_id}
                        </Td>

                        <Td columnIndex={1} sticky wider>
                          {bus.bus_code || "-"}
                        </Td>

                        <Td>{bus.plate_number || "-"}</Td>
                        <Td>{bus.driver_id || "-"}</Td>
                        <Td>{bus.vendor_id || "-"}</Td>
                        <Td>{bus.status || "-"}</Td>
                        <Td>{formatDateTime(bus.created_at)}</Td>
                        <Td>{bus.notes || "-"}</Td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </TableShell>
            </Card>
          </Stack>
        </div>
      </ScreenContent>
    </StandardScreen>
  );
}